import { METHOD } from './method'

export const API_SOP = {
    LIST: {
        api: '/v1/hr-adm/sop/list',
        method: METHOD.POST,
    },
    CREATE: {
        api: '/v1/hr-adm/sop',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/hr-adm/sop',
        method: METHOD.PUT,
    },
    UPLOAD_URL: {
        api: '/v1/hr-adm/sop/storage-url/sop-document',
        method: METHOD.POST,
    },
    DELETE: {
        api: '/v1/hr-adm/sop/delete',
        method: METHOD.POST,
    },
    ARCHIVE: {
        api: '/v1/hr-adm/sop/archive',
        method: METHOD.PUT,
    },
    DETAIL: {
        api: '/v1/hr-adm/sop',
        method: METHOD.GET,
    },
    CATEGORY_LIST: {
        api: '/v1/hr-adm/sop/support/categories',
        method: METHOD.GET,
    },
    CATEGORY_FILTER: {
        api: '/v1/hr-adm/sop/support/filter/categories',
        method: METHOD.GET,
    },
    EMPLOYEE_LIST: {
        api: '/v1/hr-adm/sop/support/employees',
        method: METHOD.GET,
    },
    EMPLOYEE_TYPE_LIST: {
        api: '/v1/hr-adm/sop/support/employee-types',
        method: METHOD.GET,
    },
}
